<template>
    <div>
        <el-form ref="form" label-width="20px" :model="formItem" :rules="rules" class="form-wrap">
            <el-form-item label="" prop="period">
                <el-checkbox v-model="item.checked" v-for="item in periodOptions" :disabled="isView||item.disabled">{{item.display_name}}</el-checkbox>
            </el-form-item>
            <el-form-item v-if="checkedLatestDays&&!isRemove" label="自定义最近天数限制：" prop="data_days" label-width="150px">
                <el-input v-model.number="formItem.data_days" size="mini" :disabled="isView||latestDaysDisabled" style="width: 150px;" placeholder="请输入天数"></el-input>
                <span class="text-color-gray font12px ml20">不包含今天，用户设置的自定义最近天数的输入值不可超过此处限制</span>
            </el-form-item>
            <el-form-item v-if="checkedStartDate&&!isRemove" label="自定义开始日期限制：" prop="start_date" label-width="150px">
                <el-date-picker
                    :disabled="isView||startDateDisabled"
                    style="width: 150px;"
                    size="mini"
                    v-model="formItem.start_date"
                    :picker-options="startPickerOptions"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    type="date"
                    placeholder="请选择日期">
                </el-date-picker>
                <span class="text-color-gray font12px ml20">用户不可选择此处限制之前的日期</span>
            </el-form-item>
        </el-form>
        <div class="dialog-footer pt20 tac" v-if="isView">
            <el-button type="default" @click="handleClose" class="action-btn mr20">关闭</el-button>
        </div>
        <div class="dialog-footer pt20 tac" v-else>
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">保存</el-button>
        </div>
    </div>
</template>

<script>
    import { cloneDeep } from 'lodash'
    export default {
        name: "StatisticalPeriodModal",
        props:{
            isView:{
                type: Boolean,
                default:false,
            },
            periodConfig:Object,
            isRemove:{
                type: Boolean,
                default:false,
            },
            page:{
                type: Object,
                required: true
            },
            fields: {
                type: Array,
                required: true
            },
            cbs:{
                type:Object,
            },
        },
        data(){
            let _this = this;
            const validPeriod = (rule, value, callback) =>{
                if(!_this.isRemove&&_this.periodOptions.length>0&&_this.periodOptions.every(item=>!item.checked)){
                    callback(new Error('请至少选择一个选项'));
                }else{
                    callback();
                }
            };
            const validDataDays = (rule, value, callback) =>{
                if(_this.isRemove){
                    callback();
                }else{
                    if(_this.formItem.data_days===0){
                        callback(new Error('请输入大于0的整数'));
                    }else if(!_this.formItem.data_days){
                        callback();
                    }else if(isNaN(_this.formItem.data_days)||+_this.formItem.data_days<=0||(''+_this.formItem.data_days).includes('.')){
                        callback(new Error('请输入大于0的整数'));
                    }else if(_this.formItem.data_days<1||_this.formItem.data_days>366){
                        callback(new Error('自定义最近天数最小为1，最大366'));
                    }else{
                        callback();
                    }
                }
            };

            return {
                formItem:{
                    period:[],
                    data_days:'',
                    start_date:'',
                },
                startPickerOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        return time.getTime() > Date.now()-1000*60*60*24;
                    },
                },
                rules:{
                    period:[
                        { validator: validPeriod, trigger: 'blur' },
                    ],
                    data_days:[
                        { validator: validDataDays, trigger: 'blur' },
                    ],
                },
                periodOptions:[],
            }
        },
        computed:{
            checkedLatestDays(){
                let actionItem = this.periodOptions.find(item=>item.name=='customize_the_latest_days');
                return actionItem&&actionItem.checked;
            },
            checkedStartDate(){
                let actionItem = this.periodOptions.find(item=>item.name=='customize_the_start_date');
                return actionItem&&actionItem.checked;
            },
            periodVal(){
                return this.periodOptions.filter(item=>!!item.checked).map(item=>item.id);
            },
            latestDaysDisabled(){
                let actionItem = this.periodOptions.find(item=>item.name=='customize_the_latest_days');
                return !!actionItem.disabled;
            },
            startDateDisabled(){
                let actionItem = this.periodOptions.find(item=>item.name=='customize_the_start_date');
                return !!actionItem.disabled;
            },
        },
        watch: {
            fields: {
                handler(new_value) {
                    this.periodOptions = cloneDeep(new_value);
                    let config = this.periodConfig||{};

                    if(config.customize_the_latest_days){
                        this.formItem.data_days = config.customize_the_latest_days;
                    }
                    if(config.customize_the_start_date){
                        this.formItem.start_date = config.customize_the_start_date;
                    }
                },
                deep: true,
                immediate: true,
            }
        },
        methods:{
            handleClose() {
                this.$emit('close');
            },
            handleSubmit() {
                this.$refs.form.validate((valid) => {
                    if(valid){
                        this.formItem.period = [...this.periodVal];
                        if(this.isRemove){
                            /* 批量编辑：批量去除权限 */
                            this.cbs.onSubmit(this.page,{
                                period:this.periodOptions.filter(item=>!!item.checked).map(item=>item.id),
                            })
                        }else{
                            this.cbs.onSubmit(this.page,{
                                data_days:this.checkedLatestDays?this.formItem.data_days:'',
                                start_date:this.checkedStartDate?this.formItem.start_date:'',
                                period:this.periodOptions.filter(item=>!!item.checked).map(item=>item.id),
                            });
                        }
                        this.handleClose();
                    }else{
                        console.log('error submit!!');
                        return false;
                    }
                });

            },
        }
    }
</script>

<style scoped>

</style>
